import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-pnr-code',
  templateUrl: './pnr-code.component.html',
  styleUrls: ['./pnr-code.component.scss'],
})
export class PnrCodeComponent  implements OnInit {

  pnrCode:String=''

  constructor(private globalService:GlobalService) { }

  ngOnInit() {}

  close(){
    this.globalService.closeModal(this.pnrCode);
  }

}
